import '../css/distributors.scss';
import {render} from 'preact';
import {DistributorApp} from '@containers/Distributors';
import Modal from '@plugins/modal';
import axios from 'axios';
import {createSearchContext} from '@ultradent/upi-fuzzy-search'

document.addEventListener( 'DOMContentLoaded', () => {
    const groupedList = document.getElementById( 'distributor-search--container' );

    if ( groupedList ) {
        groupedList.innerHTML = '';
        render( <DistributorApp countryId={groupedList.dataset.countryId}/>, groupedList );
    }

    // todo -> only initialize if the page has the country Index
    // initialize content modals for countries we avoid linking directly to the distributor page
    const distributorModalLinks = document.querySelectorAll( '[data-source-url]' );
    distributorModalLinks.forEach( link => {
        link.addEventListener( 'click', async ( e ) => {
            e.preventDefault();
            const doc = await getDistributorContent( link.dataset.sourceUrl );

            Modal.getInstance().open( {
                content: `
                <div>
                    <header class="modal-header">
                        <h2 class="headline-sm flex items-center">${link.innerHTML}</h2>
                    </header>
                    <div class="modal-pop modal-body">${doc}</div>
                </div>
                `,
                width: 640
            } );
        } );
    } );

    // todo -> only initialize if the page has the country Index
    initializeCountryIndexFilter();
} );

function initializeCountryIndexFilter () {

    // Initializes Country Filter/Search
    const selectionMap = document.getElementById( 'country-select-map' );
    const selectionMapItems = selectionMap?.querySelectorAll( '[data-region]' ) ?? [];

    const distributeMetaLinks = document.querySelectorAll( '[data-country-meta]' );
    distributeMetaLinks.forEach( item => {
        const meta = item.dataset.countryMeta.split( '|' );
        item.meta1 = meta[0];
        item.meta2 = meta[1];
    } );

    let currentCountryList = [...distributeMetaLinks];
    let searchContext = createSearchContext( currentCountryList, ['meta1', 'meta2'] );
    const regionSelect = document.getElementById( 'region-select' );
    const countryFilterInput = document.getElementById( 'country-filter' );
    const resetButton = document.querySelector( '[data-action="reset-selection"]' );

    function updateSearchContext () {
        searchContext = createSearchContext( currentCountryList, ['meta1', 'meta2'] );
        countryFilterInput.value = '';
    }

    function resetSelections () {
        regionSelect.value = '';
        onUpdateRegionSelection( '' );
    }

    function updateMapSelection ( region ) {
        selectionMapItems.forEach( item => {
            const colors = item.dataset.colors.split( '|' );
            item.style.fill = colors[0];
            item.classList.remove( 'active' );
            if ( item.dataset.region === region ) {
                item.classList.add( 'active' );
                item.style.fill = colors[2];
            }
        } );
    }

    function toggleOrphanedGroups () {
        const orphanedGroups = document.querySelectorAll( '.section-dist-region' );

        orphanedGroups.forEach( group => {
            group.classList.remove( 'hidden' );
            group.classList.add( 'flex' );
            if ( group.querySelectorAll( '.country-item.flex' ).length === 0 ) {
                group.classList.add( 'hidden' );
                group.classList.remove( 'flex' );
            }
        } );
    }

    function onUpdateRegionSelection ( region ) {
        distributeMetaLinks.forEach( item => {
            item.classList.add( 'hidden' );
            item.classList.remove( 'flex' );
        } );

        currentCountryList = [...distributeMetaLinks].filter( item => {
            const itemRegion = item.dataset.countryMeta?.split( '|' )[0];
            return region === '' || region === itemRegion;
        } );

        currentCountryList.forEach( item => {
            item.classList.remove( 'hidden' );
            item.classList.add( 'flex' );
        } );

        toggleOrphanedGroups();
        updateSearchContext();
        updateMapSelection( region );
    }

    if ( resetButton ) {
        resetButton.addEventListener( 'click', e => {
            e.preventDefault();
            resetSelections();
        } );
    }

    if ( !regionSelect || !countryFilterInput ) {
        return;
    }

    selectionMapItems.forEach( item => {
        const colors = item.dataset.colors?.split( '|' ) ?? [];
        item.addEventListener( 'mouseenter', () => {
            item.style.fill = colors[1];
        } );
        item.addEventListener( 'mouseleave', () => {
            item.style.fill = item.classList.contains( 'active' ) ? colors[2] : colors[0];
        } );
    } );

    regionSelect.addEventListener( 'change', ( e ) => {
        const region = e.target.value;
        onUpdateRegionSelection( region );
    } );

    countryFilterInput.addEventListener( 'input', ( e ) => {
        const query = e.target.value;
        const {results} = searchContext.query( query );
        currentCountryList.forEach( item => {
            item.classList.add( 'hidden' );
            item.classList.remove( 'flex' );
        } );
        results.forEach( item => {
            item.classList.remove( 'hidden' );
            item.classList.add( 'flex' );
        } );
        toggleOrphanedGroups();
    } );

    selectionMapItems.forEach( item => {
        item.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            const region = item.dataset.region;

            // if the region is already selected, reset the selection
            if ( region === regionSelect.value ) {
                resetSelections();
                return;
            }

            regionSelect.value = region;
            onUpdateRegionSelection( region );
        } );
    } )

    onUpdateRegionSelection( regionSelect.value );
}

async function getDistributorContent ( url ) {
    try {
        const {data} = await axios.get( url );

        const parser = new DOMParser();
        const doc = parser.parseFromString( data, 'text/html' );
        return doc.querySelector( '.distributor-container' )?.innerHTML;
    }
    catch ( err ) {
        window.location.href = url;
    }
}
